import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import validator from 'validator';

import { IMaskInput } from 'react-imask';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import AccountCircle from '@mui/icons-material/AccountCircle';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { setDataAction  } from 'redux/actions/getFormActions';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const useStyles = makeStyles((theme) => ({
    select: {
        '& .MuiSvgIcon-root': {
            color: theme.palette.primary.main
        },
        '&:hover': {
            backgroundColor: '#e4dfdf6b'
        }
    },
    icon: {
        fill: theme.palette.primary,
    },
}));

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="(#00) 000-0000"
      definitions={{
        '#': /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const Form4 = (props) => {
    const {actions, token, formData, handleNext, handleBack } = props;
    const classes = useStyles();
    const [data, setFormData] = useState({
      tenant_fname: null,
      tenant_lname: null,
      tenant_phone: null,
      tenant_email: null,
      tenant_address: null,
    });

    const [valid, setValid] = useState({
      tenant_fname: true,
      tenant_lname: true,
      tenant_phone: true,
      tenant_email: true,
      tenant_address: true,
    })

    const [disabled, setDisable] = useState(true);
    
    useEffect(() => {
      setFormData({
        tenant_fname: formData.data.tenant_fname,
        tenant_lname: formData.data.tenant_lname,
        tenant_phone: formData.data.tenant_phone,
        tenant_email: formData.data.tenant_email,
        tenant_address: formData.data.tenant_address,
        tenant_dob: formData.data.tenant_dob
      });
    }, [formData])

    const handleChange = (e, label) => {
      const value = e.target.value;
      setFormData({...data, [label]:value});
      if(label === 'tenant_email') {
        setValid({...valid, tenant_email:validator.isEmail(value)});
      } 
      if (label === 'tenant_phone') {
        setValid({...valid, tenant_phone: (value.length === 14 ? true : false) });
      }
    };

    const handleBirthDate = (e) => {
      if(e && e['$d'] != 'Invalid Date') {
        const value = new Date(e['$d']).toISOString().slice(0, 10);
        setFormData({...data, tenant_dob: value});
      }
    }

    const handleNextButton = () => {
        actions.setDataAction({
            ...formData.data,
            tenant_fname: data.tenant_fname,
            tenant_lname: data.tenant_lname,
            tenant_phone: data.tenant_phone,
            tenant_email: data.tenant_email,
            tenant_address: data.tenant_address,
            tenant_dob: data.tenant_dob
        })
        handleNext();
    }
  return (
    <Fragment>
      <Typography variant="h5" textAlign="center" color="primary" sx={{mt: 5}}>
        Tenant Contact Information
      </Typography>
          <Grid container justifyContent='center' sx={{ my: 1, mt: 3 }}>
              <Grid item xs={5}>
                <Grid container justifyContent="center" alignItems="center">
                  <Grid item xs={2} sx={{p:1, mt:2}}>
                    <Grid container justifyContent="center">
                      <AccountCircle sx={{fontSize: 40 }} color="primary"/>
                    </Grid>
                  </Grid>
                  <Grid item xs={9} sx={{ml:1}}>
                    <Typography variant="body2" color="primary">First Name</Typography>
                    <TextField
                        error={!data.tenant_fname}
                        variant="standard"
                        color={data.tenant_fname ? "primary" : "error"}
                        required
                        autoFocus
                        fullWidth
                        value={data.tenant_fname}
                        onChange={(e) => handleChange(e, 'tenant_fname')} 
                        />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={5}>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={2} sx={{p:1, mt:2, ml:1}}>
                      <Grid container justifyContent="center">
                        <AccountCircle sx={{fontSize: 40 }} color="primary"/>
                      </Grid>
                    </Grid>
                    <Grid item xs={9} sx={{ml:1}}>
                      <Typography variant="body2" color="primary">Last Name</Typography>
                      <TextField
                          error={!data.tenant_lname}
                          variant="standard"
                          color={data.tenant_lname ? "primary" : "error"}
                          required
                          autoFocus
                          fullWidth
                          value={data.tenant_lname}
                          onChange={(e) => handleChange(e, 'tenant_lname')} 
                          />
                    </Grid>
                  </Grid>
              </Grid>
          </Grid>
          <Grid container justifyContent='center' sx={{ my: 1 }}>
              <Grid item xs={5}>
                <Grid container justifyContent="center" alignItems="center">
                  <Grid item xs={2} sx={{p:1, mt:2}}>
                    <Grid container justifyContent="center">
                      <EmailIcon sx={{fontSize: 40 }} color="primary"/>
                    </Grid>
                  </Grid>
                  <Grid item xs={9} sx={{ml:1}}>
                      <Typography variant="body2" color="primary">Email</Typography>
                      <TextField
                          error = {!valid.tenant_email && data.tenant_email}
                          variant="standard"
                          color={data.tenant_email ? "primary" : "error"}
                          required
                          fullWidth
                          value={data.tenant_email}
                          onChange={(e) => handleChange(e, 'tenant_email')} 
                      />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={5}>
                <Grid container justifyContent="center" alignItems="center">
                  <Grid item xs={2} sx={{p: 1, mt: 2}}>
                    <Grid container justifyContent="center">
                      <PhoneIcon sx={{fontSize: 40 }} color="primary"/>
                    </Grid>
                  </Grid>
                  <Grid item xs={9} sx={{ml:1}}>
                      <Typography variant="body2" color="primary">Phone Number</Typography>
                      <TextField
                          error={!valid.tenant_phone && data.tenant_phone}
                          variant="standard"
                          color={data.tenant_phone ? "primary" : "error"}
                          required
                          // autoFocus
                          fullWidth
                          value={data.tenant_phone}
                          onChange={(e) => handleChange(e, 'tenant_phone')}
                          helperText={(!valid.tenant_phone && data.tenant_phone) && 'Invalid Input'}
                          InputProps={{
                            inputComponent: TextMaskCustom
                          }}
                      />
                  </Grid>
                </Grid>
              </Grid>
          </Grid>
          <Grid container justifyContent='center' sx={{ my: 1 }}>
            <Grid item xs={5}>
              <Grid container justifyContent="center" alignItems="center">
                <Grid item xs={2} sx={{p: 1, mt: 2}}>
                  <Grid container justifyContent="center">
                    <CalendarMonthIcon sx={{fontSize: 40 }} color="primary"/>
                  </Grid>
                </Grid>
                <Grid item xs={9} sx={{ml:1}}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          variant="standard"
                          label="Date of Birth"
                          inputFormat="DD/MM/YYYY"
                          minDate="01/01/1950"
                          value={data.tenant_dob}
                          onChange={(e) => handleBirthDate(e)}
                          renderInput={(params) => <TextField fullWidth variant="standard" {...params} sx={{svg: {color: '#702572'}}} />}
                        />
                      </LocalizationProvider>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={5}>
              <Grid container justifyContent="center" alignItems="center">
                <Grid item xs={2} sx={{p:1, mt:2}}>
                  <Grid container justifyContent="center">
                    <LocationOnIcon sx={{fontSize:40}} color="primary"/>
                  </Grid>
                </Grid>
                <Grid item xs={9} sx={{ml:1}}>
                    <Typography variant="body2" color="primary">Address </Typography>
                    <TextField
                        variant="standard"
                        color={data.tenant_address ? "primary" : "error"}
                        required
                        fullWidth
                        value={data.tenant_address}
                        onChange={(e) => handleChange(e, 'tenant_address')} 
                    />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', py: 2, mt:3 }}>
                <Button
                  onClick={handleBack}
                  sx={{ mr: 1 }}
                  variant="contained"
                >
                Back
                </Button>

            <Button 
              onClick={handleNextButton} 
              variant="contained" 
              disabled={!(data.tenant_fname && data.tenant_lname && data.tenant_email && data.tenant_address && data.tenant_phone && valid.tenant_email && valid.tenant_phone)}
            >
                <Typography variant='body1' >
                    Next
                </Typography>
            </Button>
        </Box>
    </Fragment>
  );
}

const mapStateToProps = (state) => {
    return {
        formData: state.formData
    };
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
      actions: bindActionCreators({ 
            setDataAction, 
        }, dispatch),
    };
  };
  
export default connect(mapStateToProps, mapDispatchToProps)(Form4);
